<template>
    <b-container>
        <h1>User Policy Summary</h1>
        <div v-if="results.length > 0">
        <table class="table table-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Tasks</th>
          <th>Policies</th>
          <th>Servicing</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in results" :key="user.id">
          <td>{{ user.name }}</td>
          <td>
            <span class="badge badge-primary mr-2" title="Open">{{ user.tasks_count }}</span>
            <span class="badge badge-success mr-2" title="New">{{ user.tasks_new }}</span>
            <span class="badge badge-danger mr-2" title="Overdue">{{ user.tasks_overdue }}</span>
          </td>
          <td>
            <span class="badge badge-primary mr-2" title="All">{{ user.policies }}</span>
            <span class="badge badge-info mr-2" title="Quoting">{{ user.policies_quoting }}</span>
            <span class="badge badge-warning mr-2" title="Underwriting">{{ user.policies_underwriting }}</span>
            <span class="badge badge-success mr-2" title="Approved not Expired">{{ user.policies_approved }}</span>
            <span class="badge badge-danger mr-2" title="Expired">{{ user.policies_expired }}</span>
          </td>
          <td>
            <span class="badge badge-primary mr-2" title="Servicing">{{ user.policies_servicing }}</span>
            <span class="badge badge-info mr-2" title="Writing">{{ user.policies_writing }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
    <div v-else align="center">
    <b-alert variant="secondary" show>
        <strong>Loading...</strong>
    </b-alert>
    </div>

    </b-container>
</template>

<script>
import ReportDataService from '@/services/ReportDataService';

export default {
    name: 'UserPolicySummary',

    data() {
        return {
            fields: ['name', 'Tasks', 'Policies', 'Servicing'],
            results: []
        }
    },
    created() {
        ReportDataService.getUsersPolicySummary().then((res) => {
      const users = res.data.users;

      for (const userId in users) {
        if (Object.hasOwn(users, userId)) {
          const user = users[userId];
          this.results.push({
            name: user.name_first + " " + user.name_last,
            tasks_count: user.tasks_count,
            tasks_new: user.tasks_new,
            tasks_overdue: user.tasks_overdue,
            policies: user.policies,
            policies_approved: user.policies_approved,
            policies_expired: user.policies_expired,
            policies_quoting: user.policies_quoting,
            policies_servicing: user.policies_servicing,
            policies_underwriting: user.policies_underwriting,
            policies_writing: user.policies_writing
          });
        }
      }
    }).catch((error) => {
      console.error('Error fetching user policy summary:', error);
    });
  
    }
}

</script>